import { useQuery } from '@tanstack/react-query';
import { fetchTenantById } from '@/services/platform-admin-api';

export function usePlatformTenant(id: string | undefined) {
  return useQuery({
    queryKey: ['platform', 'tenants', id],
    queryFn: () => fetchTenantById(id as string),
    enabled: !!id,
    staleTime: 30_000,
  });
}
